import { HttpErrorResponse } from '@angular/common/http';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { ModalDialogComponent } from 'src/app/components/modals/modal-dialog/modal-dialog.component';
import { MeasurementResponse } from 'src/app/models/product.model';
import { ResponseObject } from 'src/app/models/response-object.model';
import { BTNDetail, ScaleNote, ScaleNoteDetail } from 'src/app/models/scale-note';
import { ProductService } from 'src/app/services/product.service';
import { ScaleNoteService } from 'src/app/services/scale-note.service';

@Component({
  selector: 'app-scale-note-details',
  templateUrl: './scale-note-details.component.html',
  styleUrls: ['./scale-note-details.component.scss']
})
export class ScaleNoteDetailsComponent implements OnInit {
  @Output() close = new EventEmitter<boolean>();
  @Input() noteId: number;
  @Input() note: ScaleNote;
  @Output() closed = new EventEmitter<boolean>();
  @Input() showModal: boolean = false;
  measurements: MeasurementResponse = null;

  scaleNoteDetails: ScaleNoteDetail[] = [];
  scaleNoteData: ScaleNote = null;
  btnDetails: BTNDetail[] = [
      { id: 1, name: 'Bruto' },
      { id: 2, name: 'Tara' },
      { id: 3, name: 'Neto' }
    ];

  constructor(
    private toastService: ToastrService,
    private productService: ProductService,
    private scaeleNoteService: ScaleNoteService
  ) { }

  ngOnInit(): void {
    this.getDetails();
  }

  getDetails() {
    if (!this.noteId) {
      return;
    }
    this.scaeleNoteService.getScaleNoteById(this.noteId).subscribe({
      next: (response: ResponseObject) => {
        this.scaleNoteData = response.data;
        this.scaleNoteDetails = response.data.details;
        this.getMeasurement();
      },
      error: (error: HttpErrorResponse) => {
        this.toastService.error("Error al obtener los detalles de la nota de entrada", "Error");
      }
    });
  }
  getMeasurement() {
    let measureId = this.scaleNoteData.productData.measurement;

    this.productService.getMeasurementsByMeasurementId(measureId).subscribe({
      next: (response: ResponseObject) => {
        this.measurements = response.data;
      },
      error: (error: HttpErrorResponse) => {
        this.toastService.error(error.error.message);
      }
    });
  }

  formatDate(date: any): Date {
    return new Date(date);
  }

  closeModal(modal: ModalDialogComponent) {
    modal.onClose();
    this.closed.emit(false);
  }

  closedCreateNote() {
    this.closed.emit(false);
    this.showModal = false;
  }

}
